<template>
  <div v-show="!$route.query.userId" class="login">
    <div class="information-box">
      <div class="info-top">
        <div class="middle">
          <img src="../assets/image/login/logo.png">慧师行
        </div>
        <h1> 教师专业发展平台 </h1>
      </div>

      <div class="info-cent">
        <el-form ref="form" status-icon :model="form" :rules="rules">
          <el-form-item prop="userCode">
            <el-input @keyup.enter.native="login" placeholder="账户" v-model="form.userCode" prefix-icon="el-icon-user">
            </el-input>
          </el-form-item>
          <el-form-item prop="userPwd">
            <el-input @keyup.enter.native="login" placeholder="密码" type="password" v-model="form.userPwd"
                      prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <el-form-item prop="verCode" class="validate-container">
            <el-input v-model="form.verCode" style="width:140px" placeholder="验证码" prefix-icon="el-icon-lock"
                      :maxlength="4" @keyup.enter.native="login" />
            <img :src="validateImg" class="validateImg" @click="getVerCode()">
          </el-form-item>
          <el-form-item>
            <el-button class="loginBtn" @click="login" round>立&nbsp;即&nbsp;登&nbsp;录</el-button>
          </el-form-item>
        </el-form>

        <div class="save-pw clearfix">
          <div class="fl">
            <el-checkbox v-model="rememberMe">记住密码</el-checkbox>
          </div>
        </div>
        <h1 class="bq">© 2014-{{ new Date().getFullYear() }} 上海学多多教育科技有限公司版权所有</h1>
      </div>
    </div>
    </div>
</template>



<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      validateImg: "",
      form: {
        userCode: "",
        userPwd: "",
        verCode: null,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
      },
      rules: {
        userCode: [
          {
            required: true,
            message: "请输入用户名",
            trigger: ["blur", "change"],
          },
          {
            min: 3,
            max: 12,
            message: "长度必须是 3-12 位",
            trigger: ["blur", "change"],
          },
        ],
        userPwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"],
          },
          {
            min: 3,
            max: 12,
            message: "长度必须是 3-12 位",
            trigger: ["blur", "change"],
          },
        ],
        verCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur"],
          },
          {
            min: 4,
            max: 4,
            message: "长度必须是 4 位",
            trigger: ["blur"],
          },
        ],
      },
      rememberMe: false,
    };
  },
  created() {
    if (this.$route.query.userId) {
      window.localStorage.setItem('userId', this.$route.query.userId);
      this.autoLogin();
    }
    //记住密码
    else if (localStorage.getItem("rememberObj") != null) {
      let remeObj = JSON.parse(localStorage.getItem("rememberObj"));
      this.form.userCode = remeObj.userCode;
      this.form.userPwd = remeObj.userPwd;
      this.rememberMe = true;
      this.getVerCode();
    } else {
      this.getVerCode();
    }


  },

  methods: {
    getVerCode() {
      this.$axios
        .get("/oauth/getCode", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var blob = new Blob([response]);
          const a = new FileReader();
          a.readAsDataURL(blob);
          a.onload = (e) => {
            this.validateImg = e.target.result;
          };
        });
    },
    autoLogin() {
      this.$store.dispatch('getUserInfo').then(res => {
        this.$router.push("common/stu-prize");
      })
    },
    login() {
      //两个单独的对象
      let postForm = JSON.parse(JSON.stringify(this.form));
      postForm.userPwd = md5(postForm.userPwd);
      this.$axios
        .post("/oauth/loginByTeacher", this.$qs.stringify(postForm))
        .then((res) => {
          if (res.resultCode === 200) {
            localStorage.setItem("userId", res.data.userId);

            let remeberObj = {
              userCode: this.form.userCode,
              userPwd: this.form.userPwd,
            };
            //记住密码
            if (this.rememberMe) {
              localStorage.setItem("rememberObj", JSON.stringify(remeberObj));
            } else {
              if (localStorage.getItem("rememberObj") != null) {
                localStorage.removeItem("rememberObj");
              }
            }
            //登录成功
            this.$message({
              message: res.msg,
              type: "success",
              duration: 2000,
              offset: 150,
            });
            this.$router.push("common/stu-prize");
          } else {
            this.$message({
              message: res.msg,
              type: "error",
              duration: 2000,
              offset: 150,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reset() {
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: url("../assets/image/login/bg.png") no-repeat;
  background-size: 100% 100%;

  .information-box {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: 30%;
    min-width: 500px;
    max-width: 700px;
    height: 530px;

    .info-top {
      position: absolute;
      top: 0px;
      background: #fff;
      left: 0px;
      width: 100%;
      height: 140px;
      background: url("../assets/image/login/info-top.png");
      background-size: 100% 100%;
      z-index: 0;

      .middle {
        margin-top: 20px;
        text-align: center;
        font-size: 30px;
        color: @theme-color;
        font-weight: 550;

        img {
          width: 50px;
          margin-right: 10px;
          vertical-align: sub;
        }
      }

      h1 {
        margin-top: 10px;
        text-align: center;
        font-size: 30px;
        color: @theme-color;
      }
    }

    .info-cent {
      box-sizing: border-box;
      position: absolute;
      top: 109px;
      z-index: -99;
      background: #fff;
      border-radius: 7px;
      left: 11px;
      border: 1px solid #eee;
      width: 96%;
      text-align: center;
      padding: 50px;
      padding-bottom: 15px;

      .el-form {

        /deep/ .el-input__prefix,
        .el-input__suffix {
          color: @theme-color;
        }

        /deep/.el-input__inner {
          border-radius: 20px;
        }

        .loginBtn {
          margin-top: 10px;
          width: 100%;
          color: #fff;
          background: @theme-color;
        }
      }

      .save-pw {
        /deep/.el-checkbox__inner {
          border-radius: 10px;
        }

        /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
          color: #000000;
          font-size: 12px;
        }

        /deep/ .el-checkbox__label {
          padding-left: 6px;
          font-size: 12px;
        }

        .fr {
          cursor: pointer;

          a {
            color: @theme-color;
          }
        }
      }

      .bq {
        margin-top: 60px;
        color: @theme-color;
      }

      .register {
        margin-top: 15px;

        span {
          color: @theme-color;
          cursor: pointer;
        }
      }
    }

    // 验证码
    .validate-container {
      position: relative;
      text-align: left;

      .validateImg {
        position: absolute;
        right: 0px;
        width: 80px;
        height: 36px;
      }
    }
  }
}
</style>
